var map = {
	"./Aatrox.PNG": 6417,
	"./Aatrox_Vertical.PNG": 4970,
	"./Ahri.PNG": 7455,
	"./Ahri_Vertical.PNG": 4752,
	"./Akali.PNG": 4811,
	"./Akali_Vertical.PNG": 1105,
	"./Akshan.PNG": 7642,
	"./Akshan_Vertical.PNG": 9285,
	"./Alistar.PNG": 1942,
	"./Alistar_Vertical.PNG": 2107,
	"./Ambessa.PNG": 2063,
	"./Ambessa_Vertical.PNG": 9625,
	"./Amumu.PNG": 3484,
	"./Amumu_Vertical.PNG": 8735,
	"./Anivia.PNG": 4598,
	"./Anivia_Vertical.PNG": 4328,
	"./Annie.PNG": 5753,
	"./Annie_Vertical.PNG": 7439,
	"./Aphelios.PNG": 9998,
	"./Aphelios_Vertical.PNG": 5541,
	"./Ashe.PNG": 5787,
	"./Ashe_Vertical.PNG": 3845,
	"./Aurelion Sol.PNG": 5917,
	"./Aurelion Sol_Vertical.PNG": 3872,
	"./Aurora.PNG": 4597,
	"./Aurora_Vertical.PNG": 1595,
	"./Azir.PNG": 6443,
	"./Azir_Vertical.PNG": 2568,
	"./Bard.PNG": 6927,
	"./Bard_Vertical.PNG": 4234,
	"./Bel'Veth.PNG": 3958,
	"./Bel'Veth_Vertical.PNG": 7942,
	"./Blitzcrank.PNG": 9018,
	"./Blitzcrank_Vertical.PNG": 6712,
	"./Brand.PNG": 5207,
	"./Brand_Vertical.PNG": 5295,
	"./Braum.PNG": 4392,
	"./Braum_Vertical.PNG": 6264,
	"./Briar.PNG": 1013,
	"./Briar_Vertical.PNG": 932,
	"./Caitlyn.PNG": 2773,
	"./Caitlyn_Vertical.PNG": 4826,
	"./Camille.PNG": 7316,
	"./Camille_Vertical.PNG": 7556,
	"./Cassiopeia.PNG": 155,
	"./Cassiopeia_Vertical.PNG": 3268,
	"./Cho'Gath.PNG": 6978,
	"./Cho'Gath_Vertical.PNG": 439,
	"./Corki.PNG": 4606,
	"./Corki_Vertical.PNG": 7872,
	"./Darius.PNG": 4269,
	"./Darius_Vertical.PNG": 4296,
	"./Diana.PNG": 5918,
	"./Diana_Vertical.PNG": 8941,
	"./Dr. Mundo.PNG": 406,
	"./Dr. Mundo_Vertical.PNG": 5933,
	"./Draven.PNG": 2519,
	"./Draven_Vertical.PNG": 7888,
	"./Ekko.PNG": 2220,
	"./Ekko_Vertical.PNG": 4738,
	"./Elise.PNG": 8712,
	"./Elise_Vertical.PNG": 3887,
	"./Evelynn.PNG": 2573,
	"./Evelynn_Vertical.PNG": 7311,
	"./Ezreal.PNG": 613,
	"./Ezreal_Vertical.PNG": 9544,
	"./Fiddlesticks.PNG": 5187,
	"./Fiddlesticks_Vertical.PNG": 9887,
	"./Fiora.PNG": 8718,
	"./Fiora_Vertical.PNG": 5824,
	"./Fizz.PNG": 6035,
	"./Fizz_Vertical.PNG": 9790,
	"./Galio.PNG": 6087,
	"./Galio_Vertical.PNG": 8474,
	"./Gangplank.PNG": 5755,
	"./Gangplank_Vertical.PNG": 7341,
	"./Garen.PNG": 3693,
	"./Garen_Vertical.PNG": 8342,
	"./Gnar.PNG": 6833,
	"./Gnar_Vertical.PNG": 9602,
	"./Gragas.PNG": 3950,
	"./Gragas_Vertical.PNG": 6092,
	"./Graves.PNG": 4652,
	"./Graves_Vertical.PNG": 1924,
	"./Gwen.PNG": 3146,
	"./Gwen_Vertical.PNG": 2099,
	"./Hecarim.PNG": 5280,
	"./Hecarim_Vertical.PNG": 6329,
	"./Heimerdinger.PNG": 8876,
	"./Heimerdinger_Vertical.PNG": 3897,
	"./Hwei.PNG": 6828,
	"./Hwei_Vertical.PNG": 2971,
	"./Illaoi.PNG": 1991,
	"./Illaoi_Vertical.PNG": 5052,
	"./Irelia.PNG": 677,
	"./Irelia_Vertical.PNG": 8137,
	"./Ivern.PNG": 4272,
	"./Ivern_Vertical.PNG": 4145,
	"./Janna.PNG": 9633,
	"./Janna_Vertical.PNG": 2317,
	"./Jarvan IV.PNG": 6422,
	"./Jarvan IV_Vertical.PNG": 9527,
	"./Jax.PNG": 8355,
	"./Jax_Vertical.PNG": 4824,
	"./Jayce.PNG": 6026,
	"./Jayce_Vertical.PNG": 3704,
	"./Jhin.PNG": 4967,
	"./Jhin_Vertical.PNG": 9032,
	"./Jinx.PNG": 8965,
	"./Jinx_Vertical.PNG": 3517,
	"./K'Sante.PNG": 9203,
	"./K'Sante_Vertical.PNG": 3803,
	"./Kai'sa.PNG": 6840,
	"./Kai'sa_Vertical.PNG": 985,
	"./Kalista.PNG": 102,
	"./Kalista_Vertical.PNG": 7815,
	"./Karma.PNG": 856,
	"./Karma_Vertical.PNG": 6478,
	"./Karthus.PNG": 3461,
	"./Karthus_Vertical.PNG": 9918,
	"./Kassadin.PNG": 7418,
	"./Kassadin_Vertical.PNG": 1197,
	"./Katarina.PNG": 7031,
	"./Katarina_Vertical.PNG": 1495,
	"./Kayle.PNG": 8123,
	"./Kayle_Vertical.PNG": 750,
	"./Kayn.PNG": 7143,
	"./Kayn_Vertical.PNG": 8894,
	"./Kennen.PNG": 4703,
	"./Kennen_Vertical.PNG": 5266,
	"./Kha'Zix.PNG": 4499,
	"./Kha'Zix_Vertical.PNG": 636,
	"./Kindred.PNG": 4776,
	"./Kindred_Vertical.PNG": 6501,
	"./Kled.PNG": 4379,
	"./Kled_Vertical.PNG": 2370,
	"./Kog'Maw.PNG": 3999,
	"./Kog'Maw_Vertical.PNG": 3027,
	"./LeBlanc.PNG": 9673,
	"./LeBlanc_Vertical.PNG": 2698,
	"./Lee Sin.PNG": 6997,
	"./Lee Sin_Vertical.PNG": 1694,
	"./Leona.PNG": 1315,
	"./Leona_Vertical.PNG": 7903,
	"./Lillia.PNG": 5903,
	"./Lillia_Vertical.PNG": 7415,
	"./Lissandra.PNG": 9996,
	"./Lissandra_Vertical.PNG": 5022,
	"./Lucian.PNG": 632,
	"./Lucian_Vertical.PNG": 1575,
	"./Lulu.PNG": 1933,
	"./Lulu_Vertical.PNG": 564,
	"./Lux.PNG": 8437,
	"./Lux_Vertical.PNG": 3366,
	"./Malphite.PNG": 1599,
	"./Malphite_Vertical.PNG": 4422,
	"./Malzahar.PNG": 7210,
	"./Malzahar_Vertical.PNG": 5442,
	"./Maokai.PNG": 9821,
	"./Maokai_Vertical.PNG": 2374,
	"./Master Yi.PNG": 3386,
	"./Master Yi_Vertical.PNG": 798,
	"./Mel.PNG": 2207,
	"./Mel_Vertical.PNG": 9522,
	"./Milio.PNG": 1850,
	"./Milio_Vertical.PNG": 5586,
	"./Miss Fortune.PNG": 5643,
	"./Miss Fortune_Vertical.PNG": 9997,
	"./Mordekaiser.PNG": 180,
	"./Mordekaiser_Vertical.PNG": 2403,
	"./Morgana.PNG": 6273,
	"./Morgana_Vertical.PNG": 6510,
	"./Naafiri.PNG": 6411,
	"./Naafiri_Vertical.PNG": 9738,
	"./Nami.PNG": 456,
	"./Nami_Vertical.PNG": 9129,
	"./Nasus.PNG": 8800,
	"./Nasus_Vertical.PNG": 5163,
	"./Nautilus.PNG": 9672,
	"./Nautilus_Vertical.PNG": 215,
	"./Neeko.PNG": 6301,
	"./Neeko_Vertical.PNG": 5869,
	"./Nidalee.PNG": 6423,
	"./Nidalee_Vertical.PNG": 2111,
	"./Nilah.PNG": 4303,
	"./Nilah_Vertical.PNG": 2864,
	"./Nocturne.PNG": 1631,
	"./Nocturne_Vertical.PNG": 7723,
	"./Nunu & Willump.PNG": 4152,
	"./Nunu & Willump_Vertical.PNG": 741,
	"./Olaf.PNG": 6547,
	"./Olaf_Vertical.PNG": 7273,
	"./Orianna.PNG": 2075,
	"./Orianna_Vertical.PNG": 3529,
	"./Ornn.PNG": 8065,
	"./Ornn_Vertical.PNG": 8793,
	"./Pantheon.PNG": 261,
	"./Pantheon_Vertical.PNG": 2248,
	"./Poppy.PNG": 4193,
	"./Poppy_Vertical.PNG": 8925,
	"./Pyke.PNG": 1680,
	"./Pyke_Vertical.PNG": 949,
	"./Qiyana.PNG": 416,
	"./Qiyana_Vertical.PNG": 2890,
	"./Quinn.PNG": 9755,
	"./Quinn_Vertical.PNG": 5966,
	"./Rakan.PNG": 3666,
	"./Rakan_Vertical.PNG": 3562,
	"./Rammus.PNG": 8191,
	"./Rammus_Vertical.PNG": 3647,
	"./Rek'Sai.PNG": 4394,
	"./Rek'Sai_Vertical.PNG": 6261,
	"./Rell.PNG": 5384,
	"./Rell_Vertical.PNG": 1863,
	"./Renata Glasc.PNG": 7800,
	"./Renata Glasc_Vertical.PNG": 845,
	"./Renekton.PNG": 1073,
	"./Renekton_Vertical.PNG": 859,
	"./Rengar.PNG": 3994,
	"./Rengar_Vertical.PNG": 2103,
	"./Riven.PNG": 5030,
	"./Riven_Vertical.PNG": 6711,
	"./Rumble.PNG": 2468,
	"./Rumble_Vertical.PNG": 6513,
	"./Ryze.PNG": 9844,
	"./Ryze_Vertical.PNG": 5901,
	"./Samira.PNG": 3747,
	"./Samira_Vertical.PNG": 6075,
	"./Sejuani.PNG": 2582,
	"./Sejuani_Vertical.PNG": 7498,
	"./Senna.PNG": 1573,
	"./Senna_Vertical.PNG": 3671,
	"./Seraphine.PNG": 3367,
	"./Seraphine_Vertical.PNG": 8208,
	"./Sett.PNG": 7785,
	"./Sett_Vertical.PNG": 1012,
	"./Shaco.PNG": 5646,
	"./Shaco_Vertical.PNG": 7998,
	"./Shen.PNG": 1179,
	"./Shen_Vertical.PNG": 2239,
	"./Shyvana.PNG": 390,
	"./Shyvana_Vertical.PNG": 6775,
	"./Singed.PNG": 2486,
	"./Singed_Vertical.PNG": 6323,
	"./Sion.PNG": 1785,
	"./Sion_Vertical.PNG": 3443,
	"./Sivir.PNG": 4608,
	"./Sivir_Vertical.PNG": 1215,
	"./Skarner.PNG": 1177,
	"./Skarner_Vertical.PNG": 6211,
	"./Smolder.PNG": 6319,
	"./Smolder_Vertical.PNG": 477,
	"./Sona.PNG": 8492,
	"./Sona_Vertical.PNG": 7202,
	"./Soraka.PNG": 3365,
	"./Soraka_Vertical.PNG": 1299,
	"./Swain.PNG": 2234,
	"./Swain_Vertical.PNG": 2407,
	"./Sylas.PNG": 4278,
	"./Sylas_Vertical.PNG": 2836,
	"./Syndra.PNG": 6060,
	"./Syndra_Vertical.PNG": 2421,
	"./Tahm Kench.PNG": 5138,
	"./Tahm Kench_Vertical.PNG": 4184,
	"./Taliyah.PNG": 8370,
	"./Taliyah_Vertical.PNG": 6165,
	"./Talon.PNG": 7794,
	"./Talon_Vertical.PNG": 3677,
	"./Taric.PNG": 7048,
	"./Taric_Vertical.PNG": 1217,
	"./Teemo.PNG": 5867,
	"./Teemo_Vertical.PNG": 5058,
	"./Thresh.PNG": 4833,
	"./Thresh_Vertical.PNG": 9547,
	"./Tristana.PNG": 8849,
	"./Tristana_Vertical.PNG": 9856,
	"./Trundle.PNG": 1651,
	"./Trundle_Vertical.PNG": 1350,
	"./Tryndamere.PNG": 1737,
	"./Tryndamere_Vertical.PNG": 4215,
	"./Twisted Fate.PNG": 7669,
	"./Twisted Fate_Vertical.PNG": 2482,
	"./Twitch.PNG": 549,
	"./Twitch_Vertical.PNG": 6879,
	"./Udyr.PNG": 5674,
	"./Udyr_Vertical.PNG": 8796,
	"./Urgot.PNG": 245,
	"./Urgot_Vertical.PNG": 6452,
	"./Varus.PNG": 3165,
	"./Varus_Vertical.PNG": 4217,
	"./Vayne.PNG": 7047,
	"./Vayne_Vertical.PNG": 6535,
	"./Veigar.PNG": 8307,
	"./Veigar_Vertical.PNG": 3890,
	"./Vel'koz.PNG": 7601,
	"./Vel'koz_Vertical.PNG": 5512,
	"./Vex.PNG": 928,
	"./Vex_Vertical.PNG": 5087,
	"./Vi.PNG": 5928,
	"./Vi_Vertical.PNG": 5629,
	"./Viego.PNG": 5374,
	"./Viego_Vertical.PNG": 7417,
	"./Viktor.PNG": 4200,
	"./Viktor_Vertical.PNG": 9395,
	"./Vladimir.PNG": 7196,
	"./Vladimir_Vertical.PNG": 6008,
	"./Volibear.PNG": 7184,
	"./Volibear_Vertical.PNG": 4670,
	"./Warwick.PNG": 9426,
	"./Warwick_Vertical.PNG": 7837,
	"./Wukong.PNG": 7072,
	"./Wukong_Vertical.PNG": 4190,
	"./Xayah.PNG": 6707,
	"./Xayah_Vertical.PNG": 2608,
	"./Xerath.PNG": 253,
	"./Xerath_Vertical.PNG": 6988,
	"./Xin Zhao.PNG": 7627,
	"./Xin Zhao_Vertical.PNG": 9764,
	"./Yasuo.PNG": 2788,
	"./Yasuo_Vertical.PNG": 3204,
	"./Yone.PNG": 9910,
	"./Yone_Vertical.PNG": 629,
	"./Yorick.PNG": 8241,
	"./Yorick_Vertical.PNG": 445,
	"./Yuumi.PNG": 41,
	"./Yuumi_Vertical.PNG": 2406,
	"./Zac.PNG": 9420,
	"./Zac_Vertical.PNG": 3451,
	"./Zed.PNG": 5997,
	"./Zed_Vertical.PNG": 7735,
	"./Zeri.PNG": 2666,
	"./Zeri_Vertical.PNG": 3791,
	"./Ziggs.PNG": 431,
	"./Ziggs_Vertical.PNG": 7169,
	"./Zilean.PNG": 3871,
	"./Zilean_Vertical.PNG": 6486,
	"./Zoe.PNG": 4434,
	"./Zoe_Vertical.PNG": 6954,
	"./Zyra.PNG": 9523,
	"./Zyra_Vertical.PNG": 6015,
	"./default.PNG": 2366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;